import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError, doc, getDoc } from "firebase/firestore";
import { firestore } from "@/base";
import { getActiveLicenciadaDocumentReference } from "@/modules/licenciadas/firestore";
import useUserStore from "@/modules/users/store";
import { EMBAIXADORES_PESSOAS_COLLECTION_KEY } from "../firestore";

const useGetEmbaixadorPessoaById = (embaixadorPessoaId: string | undefined) => {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);

  return useQuery<unknown, FirestoreError, TEmbaixadorPessoa | null>({
    queryKey: [
      ...EMBAIXADORES_PESSOAS_COLLECTION_KEY,
      "getEmbaixadorPessoaById",
      { embaixadorPessoaId },
      activeEmpresaId
    ],
    queryFn: async () => {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!embaixadorPessoaId) {
        throw new Error("ID do embaixador não fornecido");
      }

      const licenciadaDocumentReference = getActiveLicenciadaDocumentReference();

      let documentReference;
      if (licenciadaDocumentReference) {
        const empresaDocumentReference = doc(licenciadaDocumentReference, "empresas", activeEmpresaId);
        documentReference = doc(empresaDocumentReference, "embaixadoresPessoas", embaixadorPessoaId);
      } else {
        documentReference = doc(firestore, "empresas", activeEmpresaId, "embaixadoresPessoas", embaixadorPessoaId);
      }

      const documentSnap = await getDoc(documentReference);

      if (!documentSnap.exists()) {
        return null;
      }

      return {
        id: documentSnap.id,
        ...documentSnap.data()
      } as TEmbaixadorPessoa;
    },
    select: (data) => (data ? (subject("TEmbaixadorPessoa", data) as unknown as TEmbaixadorPessoa) : null),
    enabled: !!activeEmpresaId && !!embaixadorPessoaId
  });
};

export default useGetEmbaixadorPessoaById;
